import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import FormAuth from '../../components/FormAuth';
import GroupInput from '../../components/GroupInput';
import Title from '../../components/Title';
import Verification from '../../components/Verification';
import useErrors from '../../hooks/useErrors';
import { useStore } from '../../stores';
import formatCpf from '../../utils/formatCpf';

export default function V4() {
  const [cpf, setCpf] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { setUserData, setVerification, userData } = useStore(
    useShallow((state) => ({
      setUserData: state.setUserData,
      setVerification: state.setVerification,
      userData: state.userData,
    }))
  );

  const { setError, removeError, getErrorMessageByFieldName, errors } =
    useErrors();

  function handleCode(e) {
    setCpf(formatCpf(e.target.value));

    removeError('code');
  }

  async function onSubmit() {
    try {
      setLoading(true);

      if (!cpf) {
        setError({ field: 'code', message: 'O cpf é obrigátorio' });
        throw new Error('O cpf está vazio');
      }

      // const { number } = userData;
      const body = { ...userData, cpf };

      setUserData(body);
      setVerification(5);
      navigate('/modelregister/v5');
    } catch (error) {
      toast.error(error.message || 'Erro ao enviar código!');

      if (error.message === 'Código inválido ou expirado') {
        setError({ field: 'code', message: 'Código inválido ou expirado' });
      }
    } finally {
      setLoading(false);
    }
  }

  const isFormValid = Boolean(cpf) && errors.length === 0;

  return (
    <FormContainer>
      <Center className="center">
        <Verification v={4} />

        <Title
          title="Valide seu número"
          subtitle="Valide seu número para começar"
        />

        <FormAuth
          onSubmit={onSubmit}
          buttonTitle="Continuar"
          next
          isLoading={loading}
          formValid={isFormValid}
        >
          <GroupInput error={getErrorMessageByFieldName('code')}>
            <label>CPF*</label>
            <input
              type="text"
              placeholder="Digite seu cpf"
              value={cpf}
              onChange={handleCode}
            />
          </GroupInput>
        </FormAuth>
      </Center>
    </FormContainer>
  );
}
